import { nanoid } from 'nanoid';

import { TOAST_VARIANTS } from '@/constants';
import { store, uiActions } from '@/store';
// TODO instead of importing store directly to call dispatch
// replace SnackbarUtils with direct calls to dispatch in each component?

export const SnackbarUtils = {
  success: (msg: string) =>
    store.dispatch(
      uiActions.addToast({
        id: nanoid(),
        message: msg,
        variant: TOAST_VARIANTS.SUCCESS,
      }),
    ),
  warning: (msg: string) =>
    store.dispatch(
      uiActions.addToast({
        id: nanoid(),
        message: msg,
        variant: TOAST_VARIANTS.WARNING,
      }),
    ),
  info: (msg: string) =>
    store.dispatch(
      uiActions.addToast({
        id: nanoid(),
        message: msg,
        variant: TOAST_VARIANTS.INFO,
      }),
    ),
  error: (msg: string) =>
    store.dispatch(
      uiActions.addToast({
        id: nanoid(),
        message: msg,
        variant: TOAST_VARIANTS.ERROR,
      }),
    ),
};
